module.exports = __webpack_public_path__ + "img/newsImg9-1.8f4b04dc.png";